export default [
  {
    key: 'p',
    name: 'Preschool'
  },
  {
    key: 'k',
    name: 'Kindergarten'
  },
  {
    key: '1',
    name: 'First Grade'
  },
  {
    key: '2',
    name: 'Second Grade'
  },
  {
    key: '3',
    name: 'Third Grade'
  },
  {
    key: '4',
    name: 'Fourth Grade'
  },
  {
    key: '5',
    name: 'Fifth Grade'
  },
  {
    key: '6',
    name: 'Sixth Grade'
  },
  {
    key: '7',
    name: 'Seventh Grade'
  },
  {
    key: '8',
    name: 'Eighth Grade'
  }
]
